import React from 'react';

import { TableAttendance } from 'views/Attendance/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <TableAttendance />
      </div>
    </div>
  );
};
